export default __webpack_public_path__ + "static/media/icon-printer.f2b9c4e9.svg";